import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MessageLayout = _resolveComponent("MessageLayout")!

  return (_openBlock(), _createBlock(_component_MessageLayout, {
    image: "./account-active.svg",
    title: "Your Nobl9 account has been already set up.",
    "contact-url": _ctx.config.supportUrl
  }, {
    action: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: _ctx.goToSignIn }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Go to Sign In page")
        ])),
        _: 1,
        __: [0]
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createTextVNode(" You already set up your Nobl9 account. It is ready to use! Sign in to start your Nobl9 journey. "))
    ]),
    _: 1,
    __: [1]
  }, 8, ["contact-url"]))
}